import { useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

export default function EditableCell({ value, onSave, type = "text", options, className = "", testId, placeholder = "—" }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);
  const committed = useRef(false);

  const commit = async (v) => {
    if (committed.current) return;
    committed.current = true;
    setEditing(false);
    if (String(v ?? "") === String(value ?? "") || (type === "number" && String(v).trim() === "")) return;
    setSaving(true);
    try { await onSave(type === "number" ? Number(v) : v); } finally { setSaving(false); }
  };

  if (options) {
    const label = options.find((o) => o.value === (value ?? ""))?.label ?? placeholder;
    return (
      <Select value={value ?? ""} onValueChange={(v) => { committed.current = false; commit(v === "__none" ? "" : v); }}>
        <SelectTrigger className={`h-7 text-xs border-transparent hover:border-stone-300 bg-transparent px-1 ${className}`} data-testid={testId}>
          <SelectValue placeholder={placeholder}>{saving ? <Loader2 className="w-3 h-3 animate-spin" /> : label}</SelectValue>
        </SelectTrigger>
        <SelectContent>{options.map((o) => <SelectItem key={o.value || "__none"} value={o.value || "__none"}>{o.label}</SelectItem>)}</SelectContent>
      </Select>
    );
  }

  if (editing) {
    return (
      <input autoFocus type={type} step={type === "number" ? "0.5" : undefined} value={draft} onChange={(e) => setDraft(e.target.value)}
        onBlur={() => commit(draft)} onKeyDown={(e) => { if (e.key === "Enter") commit(draft); if (e.key === "Escape") { committed.current = true; setEditing(false); } }}
        className={`w-full min-w-[80px] h-7 px-1 text-xs border border-[#0F4C81] rounded bg-white outline-none ${className}`} data-testid={`${testId}-input`} />
    );
  }
  return (
    <button type="button" onClick={() => { setDraft(value ?? ""); setEditing(true); }} title="Clicca per modificare"
      className={`w-full text-left min-h-[28px] px-1 rounded hover:bg-[#EFF6FF] cursor-text ${className}`} data-testid={testId}>
      {saving ? <Loader2 className="w-3 h-3 animate-spin inline" /> : (value === "" || value == null ? <span className="text-stone-300">{placeholder}</span> : String(value))}
    </button>
  );
}
